__turbopack_context__.v({
  "rating": "star-rating-module-scss-module__Xj5OIq__rating",
});
